import memoizeOne from 'memoize-one';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { UserProductGroup } from '~/Api/User/ProductGroup';
import { Filter, paginatedFetchGroups, selectGroups } from '~/ProductGroup';
import { State, ThunkDispatch } from '~/Store';

import GroupList from './GroupList';

const memoizedSelectGroups = memoizeOne((state, parentId) => {
	return selectGroups(state, new Filter(parentId, null));
});

type Props = { parentId: string | null; onFetched?: () => void };

function mapStateToProps(
	state: State,
	props: Props
): {
	groups: UserProductGroup[] | null;
	isFetching: boolean;
	hasNextPage: boolean;
} {
	const groupsState = memoizedSelectGroups(state.productGroup, props.parentId);

	return {
		groups: groupsState.status === 'not-fetched' ? null : groupsState.groups,
		isFetching: groupsState.status === 'fetching',
		hasNextPage: Boolean(groupsState.pagination && groupsState.pagination.hasNextPage()),
	};
}

function mapDispatchToProps(dispatch: ThunkDispatch<AnyAction>, props: Props) {
	return {
		onFetch: async () => {
			await dispatch(paginatedFetchGroups(new Filter(props.parentId, null), 1000));
			if (typeof props.onFetched === 'function') {
				props.onFetched();
			}
		},
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupList);
